// Constantes usadas em múltiplos lugares: opções de selects, benefícios da
// página de login, mensagens de validação e estados iniciais de formulários

import { FaFileSignature, FaFileContract, FaHeadset } from 'react-icons/fa';

/** Opções para select de Estado Civil (usado no PersonalInfoSection). Valores numéricos vêm do backend. */
export const ESTADO_CIVIL_OPTIONS = [
  { value: '8', label: 'Não Informado' },
  { value: '1', label: 'Casado(a)' },
  { value: '2', label: 'Divorciado' },
  { value: '3', label: 'Solteiro(a)' },
  { value: '4', label: 'Viúvo(a)' },
  { value: '5', label: 'União Estável' },
  { value: '6', label: 'Outros' },
  { value: '7', label: 'Separado Judicialmente' }
];

export const SEXO_OPTIONS = [
  { value: 'N', label: 'Não Informado' },
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' }
];

export const BENEFITS = [
  {
    id: 1,
    icon: FaFileSignature,
    text: 'Solicitação de Inscrições',
    description: 'Faça sua inscrição na OAB de forma digital'
  },
  {
    id: 2,
    icon: FaFileContract,
    text: 'Emissão de Certidões',
    description: 'Emita certidões online sem sair de casa'
  },
  {
    id: 3,
    icon: FaHeadset,
    text: 'Atendimento Online',
    description: 'Suporte e atendimento digital'
  }
];

export const VALIDATION_MESSAGES = {
  REQUIRED: 'Este campo é obrigatório',
  INVALID_CPF: 'CPF inválido',
  INVALID_EMAIL: 'E-mail inválido',
  INVALID_CEP: 'CEP inválido',
  INVALID_PHONE: 'Telefone inválido',
  PASSWORD_MIN_LENGTH: 'Senha deve ter no mínimo 8 caracteres',
  PASSWORD_MISMATCH: 'As senhas não coincidem',
  CEP_NOT_FOUND: 'CEP não encontrado',
  CEP_SUCCESS: 'CEP encontrado!'
};

export const INITIAL_REGISTER_FORM = {
  // Segurança
  password: '',
  confirmPassword: '',

  // Informações pessoais
  nome: '',
  tipoPessoa: 'F',                    // Padrão: Pessoa Física
  nomeSocial: '',
  cpfCnpj: '',
  sexo: 'N',
  estadoCivil: '8',
  dataNascimento: '',
  nomeMae: '',
  nomePai: '',
  municipioNaturalidade: '',
  municipioNaturalidadeNome: '',

  // Endereço residencial
  cepResidencial: '',
  cepResidencialId: '',                // ID do registro de CEP (API de endereço) - é o que a API de cadastro espera
  paisResidencial: '1',                // Brasil
  estadoResidencial: '',
  municipioResidencial: '',
  bairroResidencial: '',
  numeroResidencial: '',
  logradouroResidencial: '',
  complementoResidencial: '',
  emailResidencial: '',
  telefoneCelular: '',
  telefoneResidencial: '',
  correspondenciaResidencial: 'N',

  // Endereço comercial (opcional)
  temEnderecoComercial: false,         // Controla exibição
  cepComercial: '',
  cepComercialId: '',                  // ID do registro de CEP (API de endereço) - é o que a API de cadastro espera
  paisComercial: '1',                  // Brasil
  estadoComercial: '',
  municipioComercial: '',
  bairroComercial: '',
  numeroComercial: '',
  logradouroComercial: '',
  complementoComercial: '',
  emailComercial: '',
  telefoneComercial: '',
  telefone2Comercial: '',
  correspondenciaComercial: 'N'
};
